import { LoginState } from "@/interfaces/sdk-login";
import { tokenInfo } from "./types";

export default {
  [tokenInfo]: (state: LoginState) => state.parsedToken,
};
